import { api } from "@/lib/api";

const g = (p, params) => api.get(p, { params }).then((r) => r.data);
const post = (p, body) => api.post(p, body).then((r) => r.data);
const B = "/admin/bid-center";
const G = "/admin/groups";

export const errText = (e) => {
  const d = e?.response?.data?.detail;
  return typeof d === "string" ? d : Array.isArray(d) ? d.map((x) => x.msg).join("; ") : "Something went wrong";
};

export const bidDashboard = () => g(`${B}/dashboard`);
export const bidActivity = (params) => g(`${B}/activity`, params);
export const reviewQueue = () => g(`${B}/review-queue`);
export const classifyBid = (id, body) => post(`${B}/bids/${id}/classify`, body);
export const authorizeAuction = (id, reason) => post(`${B}/auctions/${id}/authorize`, { reason });
export const notifSettings = () => g(`${B}/notifications/settings`);
export const saveNotifSettings = (body) => api.put(`${B}/notifications/settings`, body).then((r) => r.data);
export const notifications = () => g(`${B}/notifications`);
export const emailSettings = () => g(`${B}/email/settings`);
export const saveEmailSettings = (body) => api.put(`${B}/email/settings`, body).then((r) => r.data);
export const emailDeliveries = () => g(`${B}/email/deliveries`);
export const emailTest = (body) => post(`${B}/email/test`, body);
export const softClose = () => g(`${B}/soft-close`);
export const bidReplies = () => g(`${B}/replies`);
export const liveAuctions = (ids) => api.get(`${B}/live`, { params: { horse_ids: ids.join(",") }, headers: { "X-Background": "1" } }).then((r) => r.data);
export const approveReply = (id) => post(`${B}/replies/${id}/approve`, {});
export const cancelReply = (id) => post(`${B}/replies/${id}/cancel`, {});
export const saveSoftClose = (body) => api.put(`${B}/soft-close`, body).then((r) => r.data);
export const smsStatus = () => g("/admin/sms/status");
export const smsVerify = () => post("/admin/sms/verify", {});
export const smsControl = (body) => api.put("/admin/sms/control", body).then((r) => r.data);
export const smsCredentials = (body) => api.put("/admin/sms/credentials", body).then((r) => r.data);
export const smsTest = (body) => post("/admin/sms/test", body);
export const smsPreviewAuthorize = (confirm) => post("/admin/sms/preview-test/authorize", { confirm });
export const smsPreviewSend = (body) => post("/admin/sms/preview-test/send", body);
export const smsTests = () => g("/admin/sms/tests");
export const timeCheck = (pid) => g(`/admin/bid-center/auctions/${pid}/time-check`);
export const timeCheckRun = (pid) => post(`/admin/bid-center/auctions/${pid}/time-check/run`, {});
export const rulesPreview = (pid) => g(`/admin/bid-center/auctions/${pid}/rules-preview`);
export const auctionFlags = (pid) => g(`/admin/bid-center/auctions/${pid}/flags`);
export const resolveFlag = (id, note) => post(`/admin/bid-center/flags/${id}/resolve`, { note });
export const auctionAudit = (pid) => g(`/admin/bid-center/auctions/${pid}/audit`);
export const syncDiag = (pid) => g(`/admin/bid-center/auctions/${pid}/sync-diagnostics`);
export const rulesApply = (pid) => post(`/admin/bid-center/auctions/${pid}/rules-apply`, { confirm: "APPLY" });
export const smsSession = () => api.get("/admin/sms/test-session", { headers: { "X-Background": "1" } }).then((r) => r.data);
export const smsSessionStart = (body) => post("/admin/sms/test-session/start", body);
export const smsSessionStop = () => post("/admin/sms/test-session/stop", {});
export const smsRefresh = (id) => post(`/admin/sms/tests/${id}/refresh`, {});
export const smsEventPreview = (body) => post("/admin/sms/event-test/preview", body);
export const smsEventTest = (body) => post("/admin/sms/event-test", body);
export const goLive = () => g("/admin/sms/golive");
export const goLiveSave = (item, body) => api.put(`/admin/sms/golive/${item}`, body).then((r) => r.data);
export const markRead = (id) => post(`${B}/notifications/${id}/read`);

export const listGroups = () => g(G);
export const createGroup = (body) => post(G, body);
export const updateGroup = (id, body) => api.put(`${G}/${id}`, body).then((r) => r.data);
export const listPresets = () => g(`${G}/presets/all`);
export const savePreset = (body) => post(`${G}/presets`, body);
export const deletePreset = (id) => api.delete(`${G}/presets/${id}`).then((r) => r.data);
export const horseDistribution = (hid) => g(`${G}/horse/${hid}`);
export const recommendGroups = (hid) => g(`${G}/horse/${hid}/recommendations`);
export const addDistribution = (hid, body) => post(`${G}/horse/${hid}/distribution`, body);
export const groupOverview = () => g(`${G}/overview`);
export const updateDistribution = (id, body) => api.patch(`${G}/distributions/${id}`, body).then((r) => r.data);

export const money = (a, c) => (a == null ? "—" : `$${Number(a).toLocaleString("en-CA", { maximumFractionDigits: 2 })} ${c || ""}`.trim());
